import {BehaviorSubject} from 'rxjs';
import Big from 'big.js';
import {mc} from '@px/helper/mc';
import {userApi} from '@px/api';
import {contractBiz$} from '@px/streams-contract/contract-biz';
import {contractMap$} from './config';

export const SLIP_BIZ_KEY = 'slippageSetting';
export const slipBiz$ = new BehaviorSubject([]);
export const version$ = new BehaviorSubject(1);

export function getContract(symbol: string) {
  return new Promise<ContractPair>(function (resolve, reject) {
    try {
      contractMap$.subscribe((contractMap) => {
        resolve(contractMap.get(symbol));
      });
    } catch (e) {
      reject(null);
    }
  });
}

export async function updateSlippage(symbol, value) {
  if (!value) {
    return false;
  }
  const v = Big(value).div(100).round(3).toNumber();
  const slipBiz = slipBiz$.getValue();
  const biz = slipBiz.filter((b) => !Object.prototype.hasOwnProperty.call(b, symbol));
  const version = version$.getValue();
  biz.push({[symbol]: v});
  const params = {bizVal: JSON.stringify(biz), bizKey: SLIP_BIZ_KEY, version: version + 1};
  const {data, error} = await userApi.customizeBiz(params);
  if (data) {
    mc.send('toast', 'info', {message: 'Success'});
    return true;
  }
  if (error) {
    mc.send('toast', 'error', error);
    return false;
  }
}

contractBiz$.subscribe((items) => {
  const item = items?.find((o) => o.bizKey === SLIP_BIZ_KEY);
  if (item) {
    try {
      slipBiz$.next(JSON.parse(item?.bizVal ?? ''));
      version$.next(item?.version ?? 1);
    } catch (e) {}
  }
});
